export class DesUtilities {
    private CST_FIX = '1002021010230102143';

    public createKey(serialNumber: string, programId: string): string {
        let old_char,
            new_char,
            psw_char,
            nLen,
            startPos,
            serialNumberCrypted,
            clearPsw = '',
            lNew;

        serialNumberCrypted = this.cryptSerialNumber(serialNumber, false, false);

        // calculate key
        if (serialNumberCrypted.charAt(12) === 'M') {
            serialNumberCrypted = serialNumberCrypted.slice(0, 4) + serialNumberCrypted.slice(8, 12);
            serialNumberCrypted = this.cryptDES(serialNumberCrypted, true);
            serialNumberCrypted = serialNumberCrypted.slice(0, 9);
        } else {
            serialNumberCrypted = serialNumberCrypted.slice(0, 4) + serialNumberCrypted.slice(8, 12) + '0';
        }

        lNew = !(programId.slice(-6) === '230361');
        nLen = serialNumberCrypted.length;

        // calculate the 5 start characters
        old_char = (serialNumberCrypted.charCodeAt(7) - 48) & 7;
        psw_char = programId.charCodeAt(7) - 48;
        new_char = old_char ^ psw_char;
        startPos = parseInt(new_char.toString().slice(-1)) + 1;

        if (startPos > 9) {
            startPos = 1;
        }

        for (let i = 0; i < 5; i++) {
            old_char = (serialNumberCrypted.charCodeAt(startPos - 1) - 48) & 7;
            psw_char = programId.charCodeAt(startPos - 1) - 48;
            new_char = old_char ^ psw_char;

            if (lNew) {
                clearPsw += String.fromCharCode((new_char % 25) + 65);
            } else {
                clearPsw += String.fromCharCode(new_char + 65);
            }

            startPos--;

            if (startPos <= 0) {
                startPos = nLen;
            }
        }

        return clearPsw;
    }

    private cryptSerialNumber(cSerial: string, lCrea: boolean, lDisk: boolean) {
        const nLen = this.CST_FIX.length;
        let clear_psw = '';

        if (nLen > cSerial.length) {
            cSerial += '0'.repeat(nLen - cSerial.length);
        } else {
            cSerial = cSerial.slice(0, nLen);
        }

        for (let i = 0; i < nLen; i++) {
            let old_char = cSerial.charCodeAt(i) - 48;

            if (lDisk) {
                old_char ^= 2;
            }

            let psw_char = parseInt(this.CST_FIX.charAt(i));

            if (!lCrea && old_char > 9) {
                old_char -= 7;
            }

            let new_char = old_char ^ psw_char;

            if (lCrea && new_char > 9) {
                clear_psw += String.fromCharCode(new_char + 55);
            } else {
                clear_psw += String.fromCharCode(new_char + 48);
            }
        }
        return clear_psw;
    }

    private cryptDES(xString, lCrypt, xKey = '') {
        let i, y, x, j, nShift, nRow, nCol: number;
        let cStrHex, cString, cKey, cSubKey, cKeyS, cKeyD, cChiaveIniziale, cPC1, cPC2, cPI, cPE, cTmp: string;

        let aKey = Array(16);
        let vC = Array(16);
        let vD = Array(16);
        let vL = Array(16);
        let vR = Array(16);
        let vB;

        const SHIFT_CICLI = '1122222212222221';

        let aBox = new Array(8);
        for (let i = 0; i < 8; i++) {
            aBox[i] = new Array(4);
        }

        const CONST_PC1 = '57494133251709' + '01585042342618' + '10025951433527' + '19110360524436' + '63554739312315' + '07625446383022' + '14066153453729' + '21130528201204';

        const CONST_PC2 = '141711240105' + '032815062110' + '231912042608' + '160727201302' + '415231374755' + '304051453348' + '444939563453' + '464250362932';

        const CONST_PI = '5850423426181002' + '6052443628201204' + '6254463830221406' + '6456484032241608' + '5749413325170901' + '5951433527191103' + '6153453729211305' + '6355473931231507';

        const CONST_PF = '4008481656246432' + '3907471555236331' + '3806461454226230' + '3705451353216129' + '3604441252206028' + '3503431151195927' + '3402421050185826' + '3301410949175725';

        const cPEPos = '320102030405' + '040506070809' + '080910111213' + '121314151617' + '161718192021' + '202122232425' + '242526272829' + '282930313201';

        const CONST_PP = '16072021' + '29122817' + '01152326' + '05183110' + '02082414' + '32270309' + '19133006' + '22110425';

        if (xKey === '') {
            xKey = '1111111111111111';
        }

        if (xString.length < 16) {
            xString = xString + ' '.repeat(16 - xString.length);
        } else {
            xString = xString.substring(0, 16);
        }
        cStrHex = xString;

        cKey = '';
        for (i = 0; i < 16; i += 2) {
            cSubKey = this.Hex2Bin(xKey.substr(i, 2));
            cKey = cKey + cSubKey;

            cSubKey = this.Hex2Bin(cStrHex.substr(i, 2));
            cString = cString + cSubKey;
        }

        cPC1 = this.permutation(cKey, CONST_PC1);

        vC[0] = cPC1.substring(0, 28);
        vD[0] = cPC1.substring(28); // aPC1(i + 4)

        for (i = 1; i <= 16; i++) {
            nShift = parseInt(SHIFT_CICLI.charAt(i - 1));

            cKeyS = vC[i - 1];
            cKeyD = vD[i - 1];

            cKeyS = cKeyS.substring(nShift) + cKeyS.substring(0, nShift);
            cKeyD = cKeyD.substring(nShift) + cKeyD.substring(0, nShift);

            vC[i] = cKeyS;
            vD[i] = cKeyD;

            cPC2 = this.permutation(cKeyS + cKeyD, CONST_PC2);

            aKey[i] = cPC2;
        }

        cPI = this.permutation(cString, CONST_PI);

        vL[0] = cPI.substring(0, 32);
        vR[0] = cPI.substring(32);

        y = 16;
        for (i = 1; i <= 16; i++) {
            vL[i] = vR[i - 1];

            cPE = '0'.repeat(48);

            for (j = 1; j <= 48; j++) {
                cPE = this.setCharAt(cPE, j - 1, vR[i - 1].charAt(parseInt(cPEPos.substr(j * 2 - 2, 2)) - 1));
            }

            if (lCrypt) {
                vB = this.fXOR(cPE, aKey[i]);
            } else {
                vB = this.fXOR(cPE, aKey[y]);
                y--;
            }

            cSubKey = '';
            for (x = 1; x <= 8; x++) {
                cTmp = vB.substring(x * 6 - 6, x * 6);
                nRow = this.Bin2Num(cTmp.charAt(0) + cTmp.charAt(5));
                nCol = this.Bin2Num(cTmp.substring(1, 5));
                cTmp = this.Num2Bin(aBox[x - 1][nRow], 2).substring(nCol * 2, nCol * 2 + 2);
                cSubKey = cSubKey + cTmp;
            }

            vB = this.permutation(cSubKey, CONST_PP);

            vR[i] = this.fXOR(vL[i - 1], vB);
        }

        cChiaveIniziale = this.permutation(vR[16] + vL[16], CONST_PF);

        let result = '';
        for (i = 0; i < 8; i++) {
            result = result + this.Bin2Hex(cChiaveIniziale.substring(i * 8, i * 8 + 8));
        }

        return result;
    }

    private fXOR(cD1, cD2) {
        let nLen = cD1.length;
        let result = '';

        for (let z = 0; z < nLen; z++) {
            result += cD1.charAt(z) !== cD2.charAt(z) ? '1' : '0';
        }

        return result;
    }

    private Bin2Num(Binar) {
        let nLen = Binar.length;
        let result = 0;
        let nInc = 0;

        for (let nLoop = nLen; nLoop >= 1; nLoop--) {
            nInc++;
            if (Binar.charAt(nLoop - 1) === '1') {
                result += 2 ** (nInc - 1);
            }
        }

        return result;
    }

    private Num2Bin(Number, base = 8) {
        let Num2Bin = '';
        let base2 = Math.pow(2, base) - 1;

        if (Number <= base2) {
            for (let nLoop = base; nLoop >= 1; nLoop--) {
                if (Number >= Math.pow(2, nLoop - 1)) {
                    Num2Bin += '1';
                    Number -= Math.pow(2, nLoop - 1);
                } else {
                    Num2Bin += '0';
                }
            }
        } else {
            // Valore superiore ai 8-bit
            Num2Bin = '1'.repeat(base);
        }

        return Num2Bin;
    }

    private Bin2Hex(carByte) {
        let valDec = this.Bin2Num(carByte);
        let cHex = valDec.toString(16).toUpperCase();

        if (cHex.length === 1) {
            cHex = '0' + cHex;
        }

        return cHex;
    }

    private Hex2Bin(carHex) {
        return this.Num2Bin(parseInt(carHex, 16));
    }

    private setCharAt(str, index, char) {
        return str.substring(0, index) + char + str.substring(index + 1);
    }

    private permutation(cKey, cPos) {
        let permutation = '';
        const nLen = cPos.length / 2;

        for (let j = 1; j <= nLen; j++) {
            permutation += cKey.charAt(parseInt(cPos.substr(j * 2 - 1, 2), 16) - 1);
        }

        return permutation;
    }
}
